import { render, staticRenderFns } from "./RightMenuPreview_Ap.vue?vue&type=template&id=410672cd&scoped=true"
import script from "./RightMenuPreview_Ap.vue?vue&type=script&lang=js"
export * from "./RightMenuPreview_Ap.vue?vue&type=script&lang=js"
import style0 from "./RightMenuPreview_Ap.vue?vue&type=style&index=0&id=410672cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410672cd",
  null
  
)

export default component.exports